/* src/app/errors/error-dialog/error-dialog.component.scss */
/*# sourceMappingURL=error-dialog.component-RG324TDD.css.map */
